import React from 'react';
import Datetime from 'react-datetime';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { Field } from 'formik';
import { get } from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import {
  DATE_FORMAT,
  dateToString,
  REVERSE_DASH_DATE_FORMAT,
} from '../../utils/date/Date.utils';

function FormDatePickerFieldInner(props) {
  const {
    label,
    placeholder,
    form,
    field,
    onChangeHandler,
    disabled,
    isUpperRange,
    readOnly,
    format = (value) => dateToString(value),
    timeFormat,
    dateFormat,
    required = false,
  } = props;

  const error = form.errors[field.name];
  const touched = form.touched[field.name];
  const value = form.values[field.name] || get(form.values, field.name, '') || '';

  return (
    <Row className="mb-3">
      <Col style={{ textAlign: 'left' }}>
        <FormLabel className={required && 'label-required'}>{label}</FormLabel>
        <FormGroup
          className={classNames((form.submitCount > 0 || touched) && error && 'field-error')}
        >
          <Datetime
            closeOnSelect={true}
            timeFormat={timeFormat}
            dateFormat={dateFormat}
            inputProps={{
              readOnly,
              placeholder,
              disabled: form.isSubmitting || disabled,
              className: classNames(
                'form-control form-calendar-input',
                readOnly && 'form-control--read-only',
              ),
            }}
            value={format(value)}
            onBlur={() => form.setFieldTouched(field.name, true)}
            onChange={(option) => {
              if (isUpperRange) {
                option.add(1, 'd');
                option.subtract(1, 'ms');
              }
              form.setFieldValue(field.name, moment(option).format(REVERSE_DASH_DATE_FORMAT));
              onChangeHandler(option);
            }}
          />
          {(form.submitCount > 0 || touched) && error && (
            <label
              style={{
                fontSize: 13,
                fontWeight: 400,
                color: 'red',
                marginTop: 8,
                letterSpacing: '0.02rem',
              }}
            >
              {error}
            </label>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
}

function FormDatePickerField({
  placeholder = '',
  options = [],
  onChangeHandler = () => {},
  disabled = false,
  label = '',
  isUpperRange = false,
  readOnly = false,
  timeFormat = false,
  dateFormat = DATE_FORMAT,
  format = (value) => dateToString(value),
  ...rest
}) {
  return (
    <Field
      placeholder={placeholder}
      options={options}
      onChangeHandler={onChangeHandler}
      disabled={disabled}
      label={label}
      isUpperRange={isUpperRange}
      readOnly={readOnly}
      timeFormat={timeFormat}
      dateFormat={dateFormat}
      format={format}
      {...rest}
      component={FormDatePickerFieldInner}
    />
  );
}

FormDatePickerFieldInner.defaultProps = {
  placeholder: '',
  onChangeHandler: () => {},
  disabled: false,
  label: '',
  isUpperRange: false,
  readOnly: false,
  timeFormat: false,
  dateFormat: DATE_FORMAT,
};

FormDatePickerField.defaultProps = {
  placeholder: '',
  options: [],
  onChangeHandler: () => {},
  disabled: false,
  label: '',
  isUpperRange: false,
  readOnly: false,
  timeFormat: false,
  dateFormat: DATE_FORMAT,
  format: (value) => dateToString(value),
};

export default FormDatePickerField;
